import BaseAbility from 'umg-ember-backend/abilities/base';

export default class EmbedCodeAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('asset');
  }
}
